// DS 4.8 - Grid Variant
import React from 'react';
import c from 'classnames';
import s from './FacetListGrid.scss';

interface Props {
  facets: React.ReactElement[];
  columns: number;
  gap: number;
  className?: string;
}

const FacetListGrid: React.FC<Props> = ({
  facets,
  columns,
  gap,
  className,
}) => {
  return (
    <div
      className={c(s['root'], className)}
      style={{ gridTemplateColumns: `repeat(${columns}, 1fr)`, gap }}
    >
      {facets}
    </div>
  );
};

FacetListGrid.displayName = 'FacetListGrid';

export default FacetListGrid;
